import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'

export default createListViewComponent({
  entityName: entityNames.jobStatusOptions,
  createButtonTextId: 'createJobStatusOption',
  primaryLinkTarget: 'jobStatusOptionRecord',
})()
